export const {
  REACT_APP_AWS_BUCKET: AWS_BUCKET,
  REACT_APP_AWS_REGION: AWS_REGION,
} = process.env;
